module.exports = __webpack_public_path__ + "static/media/qrcode.d264e79a.svg";